import React from 'react';

interface WebhookDataModalProps {
  isOpen: boolean;
  webhookData: any;
  onClose: () => void;
}

const WebhookDataModal: React.FC<WebhookDataModalProps> = ({
  isOpen,
  webhookData,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-4xl shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-medium text-gray-900">Webhook Data</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-sm font-medium text-gray-700">Raw Webhook Data</h4>
              <button
                onClick={() => {
                  try {
                    navigator.clipboard.writeText(JSON.stringify(webhookData, null, 2));
                  } catch (err) {
                    console.error('Failed to copy webhook data:', err);
                  }
                }}
                className="text-xs text-blue-600 hover:text-blue-800"
              >
                Copy JSON
              </button>
            </div>
            
            <pre className="text-xs text-gray-800 overflow-auto max-h-96 bg-white p-3 border rounded">
              {JSON.stringify(webhookData, null, 2)}
            </pre>
          </div>
          
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebhookDataModal;
